module.exports = __webpack_public_path__ + "static/Device-a03aa83ef024805c89ef266e3102dac3.svg";